export default "__VITE_ASSET__CJhAoARO__"